// extracted by mini-css-extract-plugin
export default {"subtitle":"ReasonModal_subtitle__JCwVx"};